import { defineMessages } from 'react-intl';

export default defineMessages({
  reviewString: {
    id: 'review',
    description: 'review',
    defaultMessage: 'Review',
  },
  checkoutString: {
    id: 'checkout',
    description: 'checkout',
    defaultMessage: 'Checkout',
  },
  checkoutProcessString: {
    id: 'checkoutProcess',
    description: 'checkout process',
    defaultMessage: 'All units will be processed for',
  },
});
